import React from "react";

export const LoaderLine = ({ loader }) => (
    <div className="error-screen__tips__loader__wrapper">
        {/* eslint-disable-next-line jsx-a11y/alt-text */}
        <img width={`${(loader?.step_number / loader?.flow_length) * 100}%`} className="error-screen__tips__loader" />
    </div>
);